<template>
  <div>
    <v-data-table
      show-expand
      :headers="headers"
      :items="requisicoes.content"
      class="elevation-1 mt-5 rounded-card card-shadow"
      :loading="loading"
      :server-items-length="requisicoes.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma solicitação encontrada"
      loading-text="Carregando Solicitações..."
      :options="optionsList"
    >
      <template v-slot:item.id="{ item }">
        <div class="text-center">
          <px-span-tooltip
          top
          :text="labelRequisicaoCodigo(item)"
          :tooltip="tooltipRequisicaoCodigo(item)"/>
        </div>
      </template>
      <template v-slot:item.identificador="{ item }">
        <px-lista-requisicao-identificador :requisicao="item" @update="emitUpdate"/>
      </template>
      <template v-slot:item.comprador.nome="{ item }">
        <px-span-tooltip top :text="comprador(item)" :tooltip="item.comprador.pessoa.nome"/>
      </template>
      <template v-slot:item.usuario="{ item }">
        <px-span-tooltip top
                         :text="usuario(item)"
                         :tooltip="(item.usuario ? item.usuario.nome : item.nomeResponsavel)"/>
      </template>
      <template v-slot:item.createdIn="{ item }">
        {{item.createdIn | date}}
      </template>
      <template v-slot:item.dataEntrega="{ item }">
        {{ item.dataEntrega | date | naoInformado}}
      </template>
      <template v-slot:item.quantidadeProdutos="{ item }">
        {{item.quantidadeProdutos}} produto(s)
      </template>
      <template v-slot:item.options="{ item }">
        <div class="div-lado-a-lado">
          <px-requisicao-urgencia-icon :urgencia="item.urgencia"/>
        </div>
        <div class="div-lado-a-lado">
          <v-btn v-if="!isRascunho(item)" icon link :to="`requisicao/${item.id}`">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
        </div>
        <div class="div-lado-a-lado">
          <lista-requisicao-menu
              v-if="hasRoleRequisicao || hasRoleComprador"
              :item="item"
              @remove="onClickRemove"
              @update="emitUpdate"
              @cancelar="onClickCancelar"/>
        </div>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">
          <px-lista-requisicao-produtos :requisicao="item"/>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { SituacaoRequisicao } from 'px-business-components';
import ListaRequisicaoIdentificador from './ListaRequisicaoIdentificador.vue';
import ListaRequisicaoProdutos from './ListaRequisicaoProdutos.vue';
import ListaRequisicaoMenu from './ListaRequisicaoMenu.vue';

export default {
  props: {
    requisicoes: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [10, 20, 30, 40, 50],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          value: 'id',
          sortable: false,
        },
        {
          text: 'Identificador',
          value: 'identificador',
        },
        {
          text: 'Empresa',
          value: 'comprador.nome',
        },
        {
          text: 'Solicitante',
          value: 'usuario',
        },
        {
          text: 'Data de entrada',
          value: 'createdIn',
        },
        {
          text: 'Prazo de entrega',
          sortable: false,
          value: 'dataEntrega',
        },
        {
          text: 'Produtos',
          sortable: false,
          value: 'quantidadeProdutos',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleRequisicao']),
    comprador() {
      return item => Vue.filter('truncate')(item.comprador.pessoa.nome, 10);
    },
    usuario() {
      return (item) => {
        const nome = item.usuario ? item.usuario.nome : item.nomeResponsavel;
        return Vue.filter('truncate')(nome, 15);
      };
    },
    isRascunho() {
      return item => item.situacao === SituacaoRequisicao.keys.RASCUNHO.key;
    },
    labelRequisicaoCodigo() {
      return requisicao => (requisicao.codigoInterno ? `${requisicao.codigoInterno} / ${requisicao.id}` : requisicao.id);
    },
    tooltipRequisicaoCodigo() {
      return requisicao => (requisicao.codigoInterno ? 'Código ERP / Código Proxpect' : 'Código Proxpect');
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    onClickRemove(item) {
      this.$emit('remove', item.id);
    },
    emitUpdate() {
      this.$emit('update');
    },
    onClickCancelar(item, motivoRecusa) {
      this.$emit('cancelar', item.id, motivoRecusa);
    },
  },
  components: {
    pxListaRequisicaoIdentificador: ListaRequisicaoIdentificador,
    PxListaRequisicaoProdutos: ListaRequisicaoProdutos,
    ListaRequisicaoMenu,
  },
};
</script>
<style scoped>
.div-lado-a-lado {
  align-items: center;
  display: inline-block;
  width: 30px;
  height: 20px;
}
</style>
